<template>
  <v-footer
    class="pa-3"
    align="center"
    color="#f0f0f0"
    style="background-color: #f0f0f0 !important;"
    :padless="true"
    dense
  >
    <v-row align="center">
      <v-col
        cols="auto"
      >
        <a
          href="https://www.systemx.net"
          target="_blank"
        ><v-img
          :src="require('@/assets/systemx_MAIN_Colour_Black.svg')"
          max-width="150px"
          max-height="100px"
          width="100%"
          height="100%"
          contain
        /></a>
      </v-col>
      <v-col
        cols="auto"
        v-if="transactionStatusId === 2"
      >
        <v-btn
          color="primary"
          outlined
          @click="downloadCertificate"
        >
          Download Certificate Of Completion
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="2">
        <v-select
          v-model="language"
          :items="languages"
          item-text="name"
          item-value="id"
          label="Language"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="auto">
        <a
          href="https://www.systemx.net/terms-of-service"
          target="_blank"
        >Terms of Service</a>
      </v-col>
      <v-col cols="auto">
        <a
          href="https://www.systemx.net/privacy-policy"
          target="_blank"
        >Privacy Policy</a>
      </v-col>
      <v-col cols="auto">
        &#169; {{ year }} SystemX
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';
import Bus from '@/bus';
export default {
  props: {
    isSigned: {
      type: Boolean,
      default: false,
    },
    transactionId: {
      type: Number,
      default: 0,
    },
    token: {
      type: String,
      default: ''
    },
    transactionStatusId: {
      type: Number,
      default: 0,
    }
  },
  name: 'PdfFooter',
  data() {
    return {
      language: 1,
      languages: [{ id: 1, name: 'English' }],
    };
  },
  computed: {
    year() {
      return moment().format('yyyy');
    },
  },
  methods: {
    async downloadCertificate() {
      if(!this.token && this.token === '') return
      const data = { Token: this.token };
      Bus.$emit('loading');
      const result = await this.$api.post(
        'sign-pdf/transactions/certificate-core/',
        data
      );
      Bus.$emit('loading');
      if (!result) return;
      const byteCharacters = atob(result.data.file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var blobPdf = new Blob([byteArray], { type: 'application/pdf' });
      const certificateName = `Completion.Certificate.${result.data.fileName}`;
      saveAs(blobPdf, certificateName);
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-column {
  padding-top: 5px;
  padding-bottom: 2px;
}
</style>
